import React, { useContext, useState } from "react";
import { TableHead, TextField } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { DateTimeFmt,fmt0left} from "../../../utils/DataUtils";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";

function BuffeTable(props) {
  const {
    selectedCountry,
  } = useContext(Context);

  var style = {
    padding: 0.6,
    textAlign: "center",
    whiteSpace: "nowrap",
  };

  return (
    <TableContainer
      component={Paper}
      sx={{  overflow: "auto" }}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.tipo}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.status}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.posicao}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.ordemSerial}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.resEntrada}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.entrada}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.respSaida}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.racks.tableHeader.saida}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!!props.sagA_Buffers &&
            props.sagA_Buffers.sagA_Buffers.map((eachObj, index) => (
              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" sx={style}>
                  {props.sagA_Buffers.sagA_Buffer_Tipos[index].bufferTipo_Nome}
                </TableCell>
                <TableCell sx={style}>
                  {props.sagA_Buffers.sagA_Buffer_Itens[index].bItem_Status}
                </TableCell>
                <TableCell sx={style}>{eachObj.buffer_Nomenclatura} </TableCell>
                <TableCell sx={style}>{fmt0left(eachObj.buffer_Ordem,4)} </TableCell>
                <TableCell sx={style}>
                  {
                    props.sagA_Buffers.sagA_Buffer_Itens[index]
                      .bItem_Entrada_User
                  }
                </TableCell>
                <TableCell sx={style}>
                  {DateTimeFmt(
                    props.sagA_Buffers.sagA_Buffer_Itens[index].bItem_Dt_Entrada
                  )}
                </TableCell>
                <TableCell sx={style}>
                  {props.sagA_Buffers.sagA_Buffer_Itens[index].bItem_Saida_User}
                </TableCell>
                <TableCell sx={style}>
                  {DateTimeFmt(
                    props.sagA_Buffers.sagA_Buffer_Itens[index].bItem_Dt_Saida
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default BuffeTable;
